// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1g00O","bigColWidth":"Table_bigColWidth__U5txO","biggerColWidth":"Table_biggerColWidth__1JviW","row":"Table_row__12924","col":"Table_col__1apJo"};